import { useCallback } from 'react';

const createOptimisticSkill = ({ name }) => {
  return {
    displayText: name
  };
};

export const useAddUserDefinedSkillOnSubmit = ({ onClose, onSkillAdd }) => {
  const onSubmit = useCallback(
    async (skill, { setSubmitting }) => {
      setSubmitting(true);

      const newUserDefinedSkill = createOptimisticSkill(skill);

      onSkillAdd(newUserDefinedSkill);

      onClose();

      setSubmitting(false);
    },
    [onClose, onSkillAdd]
  );

  return { onSubmit };
};

export default useAddUserDefinedSkillOnSubmit;
